import { Box, Typography } from '@mui/material';

const AdminHistory = () => {
 return (
  <Box className="p-4">
   <Typography variant="h5">Admin History</Typography>
  </Box>
 );
};

export default AdminHistory;


